import React, { useContext, useEffect, useState } from "react";
import "./styles.css"
import Context from "../../../../context/Context";
import CloseIcon from '@mui/icons-material/Close';
import BlockIcon from '@mui/icons-material/Block';

export const WagonTableConfirmed = ({ data, handleRemovePeca, isEdit }) => {

  const {
    selectedCountry,
    selectedWagon,
    confirmedWagon
  } = useContext(Context);



  

  const tableBody = (key, pecas, wagonData) => {
    const jsonItens = {
      ordem_Part_Short: pecas.ordem_Part_Short,
      subProduto_Desc: pecas.subProduto_Desc,
      bomba_B: pecas.Bomba_B,
      molde_Pend_Mot_Descricao: moldIsTrueStatus(pecas.molde_Pendencia?.isagA_Molde_Pendencias_Motivo.molde_Pend_Mot_Descricao),
      ordem_Serial: pecas.ordem_Serial,
      ordem_VehCod: `${pecas.ordem_VehDesc} - ${pecas.ordem_VehCod}`,
      m2_Peca: (pecas.m2_Peca / 4.5).toFixed(3),
      X: deletePeca(wagonData, pecas)
    };
    return jsonItens[key];
  };

  const moldIsTrueStatus = (status) => {
    return status ? <span data-tooltip={status}> <BlockIcon /> </span> : ""
  }

  const deletePeca = (wagonData, pecas) => {
    return <CloseIcon
      className="closeButton"
      onClick={isEdit.isEdit ? () =>  handleRemovePeca(wagonData, pecas) : () => { }}
    />
  }

  const itensWagon = [
    'ordem_Serial',
    'molde_Pend_Mot_Descricao',
    'ordem_Part_Short',
    'bomba_B',
    'subProduto_Desc',
    'ordem_VehCod',
    'm2_Peca',
    "X"
  ];

  return data.wagon.map((pecas, index) => (
    <tr className={`${(pecas.vagoes_Fornos_Pecas_Status_Molde === "MANUTENCAO") ? "BlockWagon" : ""}`} key={`RowId${index}`}>
      {itensWagon.map((item, subIndex) => (
        <td className="py-1" key={`ColTd${subIndex}`}>
          {tableBody(item, pecas, selectedWagon?.wagonInfo?.vagao_Key ? confirmedWagon : data)}
        </td>
      ))}
    </tr>
  ))
}